import { ShiftService, IShift } from '../../services/shifts.service';
import { EmployeesService, IEmployee } from '../../services/employees.service';
import * as moment from 'moment';


class SubscriptionsModalController implements ng.IComponentController {
    employee: IEmployee;
    mailcustomer: boolean = false;
    mailemployee: boolean = false;
    close: any;
    statuses: any;
    employees: any;
    selectedEmployee: any;
    public shift: any;
    private resolve: any;

    constructor(
        private ShiftService: ShiftService,
        private EmployeesService: EmployeesService,
        private $state: ng.ui.IStateService,
        private $timeout: any,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    $onInit = () => {
        this.shift = this.resolve.shift;
        this.statuses = this.resolve.statuses;
        this.getEmployee();
        this.getEmployees();
        this.setModalHeight();
    }

    private setModalHeight = () => {
        // var docHeight = $(window).height();
        // var height = docHeight - 225;
        $("#checkAvailabilityModalBody #employeelist").height(450);
    }

    private getEmployees = () => {
        var request = {
            accountId: this.shift.teamLocationAccountId,
            locationId: this.shift.teamLocationId,
            startDate: this.shift.start,
            endDate: this.shift.end,
            shiftId: this.shift.id
        };

        this.EmployeesService.customPost('availableEmployees', request, false).then((result: any) => {
            this.employees = result;
            this.employees = this.employees.filter(employeeSummary => employeeSummary.subscription)
            //this.selectedEmployee = this.employees.find(employeeSummary => employeeSummary.employee.id == this.shift.employeeId);
        });
    }

    public onSelectEmployee = () => {
        this.$timeout(() => {
            if (this.shift.employeeId) {
                this.shift.status = 6
            } else {
                this.shift.status = 2;
            }
            this.getEmployee();

        });
    }

    getEmployee = () => {
        if (this.shift.employeeId) {
            this.EmployeesService.get(this.shift.employeeId).then(employee => {
                this.employee = employee;
            });
        }
    }

    save = () => {
        if (moment(this.shift.start).isAfter(this.shift.end)) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Eindtijd ligt voor starttijd',
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
            }, (isConfirm) => {
                if (isConfirm) {

                }
            });
        } else {
            this.ShiftService.put(this.shift.id, this.shift).then((data) => {
                this.shift = data;

                if (this.mailcustomer) {
                    this.notifyTeam();
                }

                if (this.mailemployee) {
                    this.notifyEmployee();
                }
                this.closeModal();
            });
        }
    }

    private notifyTeam = () => {
        this.ShiftService.customPost('email/team', [this.shift.id]);
    }

    private notifyEmployee = () => {
        this.ShiftService.customPost('email/employee', [this.shift.id]);
    }


    // getEmployee(id) {
    //     return this.EmployeesService.get(id).then(employee => {
    //         return employee;
    //     })
    // }

    closeModal() {
        this.$state.go('^', { 'refreshShift': this.shift.id }, {
            location: true,
            reload: false,
            inherit: true,
            notify: true
        });
    }
}

export const subscriptionsModalComponent: ng.IComponentOptions = {
    controller: SubscriptionsModalController,
    bindings: {
        resolve: "<",
        close: "&"
    },
    template: <string>require('./subscriptionsModal.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/subscriptionsModal.component.ts